import React from 'react'
import {Heading} from '@myxplor/ui'
import {FormSubmit} from '@myxplor/forms'
import View from './view'

const ViewPersonnel = ({personnel = [], authorised_id, onClick, onSubmit, loading}) => (
  <div>
    <form onSubmit={event => {
      event.preventDefault()
      onSubmit(authorised_id)
    }}>
      <Heading>
        CCB Personnel
      </Heading>

      <p>Nominate a person</p>

      <fieldset>
        <ul className="authorised-personnel__list">
          {personnel.map((person) => <View 
            key={person.id}
            onClick={onClick}
            loading={loading}
            authorised_id={authorised_id}
            {...person} 
          />)}
        </ul>
      </fieldset>

      <FormSubmit 
        disabled={!authorised_id}
        loading={loading}
        loadingTitle="Saving ..."
      >{authorised_id ? 'Nominate' : 'Select someone'}</FormSubmit>
    </form>
  </div>
)

export default ViewPersonnel


// WEBPACK FOOTER //
// ./src/auth-personnel/views/index.jsx